import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router  } from 'react-router-dom';
import { Provider } from 'react-redux'; // 导入Provider
import store from './store'; // 导入Redux store
import './index.css';
import App from './App';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async';

// // 全局重定向
// window.location.replace('https://img.kdslife.com/images/1ka/jj/3g/tdf1cv-22k3.jpg');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <HelmetProvider>
  <ConfigProvider locale={zhCN}>
    <Provider store={store}> {/* 将应用程序包裹在Provider中 */}
      <Router> {/* 将 App 包裹在 HashRouter 中 */}
        <App />
      </Router>
    </Provider>
    </ConfigProvider>
  </HelmetProvider>
  // </React.StrictMode>
);

reportWebVitals();